<template>
<body>
  <cursor-fx ref="cursor" color="#6B4000" color-hover="#FA9732" inside-size="15px" outside-size="90px"></cursor-fx>
  <div class="all_box">

    <div class="member_head_4">
      <div class="apply_btn_box">
        <router-link to="ApplicationForm">
          <btn class="apply_btn" data-cursor-hover>
            応募する
          </btn>
        </router-link>
      </div>
      <div class="cb" />
      <div class="title_box_member">
        <div>
          <div class="title_h1_member en_font">Mina.Y</div>
          <div class="title_h2_member en_font">engineer</div>
        </div>
      </div>
    </div>
    <div class="Portal_box">
      <div class="Portal_contents">

        <div class="profile_title en_font">PROFILE</div>
        <div class="profile_box">
          <div class="profile_contents jp_font">
            2021年6月に中途入社。文系出身。文系からでも業務から技術を取得し活躍している方々も多くいると知り、そこから関心を抱いてIT企業へ就職。<br />
            前職にて携わっていたインフラ運用業務などを通して、これからも新しい分野に挑戦し続けたいという想いから、株式会社HESへ転職。<br />
            現在は業務自動化に関する業務に携わり、RPAを始めとしたAI構築について勉強中。<br />
            【趣味】水族館・珈琲巡り、映画鑑賞、FPSゲーム（APEX)
          </div>
        </div>

        <div class="interview_q q_decisive jp_font">入社の決め手は何ですか?</div>
        <div class="interview_box">
          <div class="interview_a jp_font">
            前職にて同じIT業界で勤務していましたが、ITスキル向上につながりにくい業務を担当していることに少し悩んでいました。<br />
            そんな中、知り合いを通じてHESのエンジニアの紹介を受けました。<br />
            話を聞く中で、興味のある分野であるRPA業務のスキルをより伸ばせること、また既存の知識を活かしつつ新たな業務への挑戦も積極的に行っていることが魅力に感じました。<br />
            特に、入社前の面談の際に自身の考えや要望を入念に聞いて下さり、社員の声をきちんと聴いて汲み取ってくださることに好印象を受け、入社することを決断しました。
          </div>
        </div>

        <div class="interview_q q_ease jp_font">働きやすさの魅力をお教えください。</div>
        <div class="interview_box">
          <div class="interview_a jp_font">
            入社から半年以上経過しましたが、業務とプライベートとの両立が大変しやすいと感じております。<br />
            もちろんその時の業務との兼ね合いもありますが、有給休暇の取得や在宅勤務への切り替え等、相談がしやすく勤務しやすい環境だと思います。<br />
          </div>
        </div>

        <div class="member_photo4" />
        <div class="member_photo_space1" />

        <div class="interview_q q_goal jp_font">今後の目標をお教えください。</div>
        <div class="interview_box">
          <div class="interview_a jp_font">
            まずは今携わっている業務自動化に関する知識を更に深めて成長したいと考えております。<br />
            ゆくゆくは顧客要望に+1で自分の提案もできるようまずは経験を積んでいきたいと思います。
          </div>
        </div>

        <div class="interview_q q_message jp_font">最後に、求職者の方へメッセージをお願いします。</div>
        <div class="interview_box">
          <div class="interview_a jp_font">
            数あるIT企業の中でたくさん悩み、就職活動をされていると思いますが、まずは面談などを通して自分の将来の目標や思いの丈をたくさん相談してみて下さい。<br />
            少しでも興味を持ってくださりましたら、まずは話を聞きに足を運んでいただければと思います！
          </div>
        </div>
          
      </div>
    </div>
    
    <div class="other_member">
      <div class="other_member_title">
        <div class="other_member_chara en_font">OTHER MEMBER</div>
      </div>

      <div class="other_member_contents">

        <!-- <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/takahashi_test.jpg" alt="">
          <p class="other_member_name">Takahashi<br />Yuta</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/otsuka_test.jpg" alt="">
          <p class="other_member_name">Otsuka<br />Chiaki</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="cb" />

        <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/yamada_test.jpg" alt="">
          <p class="other_member_name">Yamada<br />Mina</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/miyama_test.jpg" alt="">
          <p class="other_member_name">Miyama<br />Tomohiro</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="cb" /> -->



        <!-- <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/takahashi_test.jpg" alt="">
          <p class="other_member_name">Takahashi<br />Yuta</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/otsuka_test.jpg" alt="">
          <p class="other_member_name">Otsuka<br />Chiaki</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/yamada_test.jpg" alt="">
          <p class="other_member_name">Yamada<br />Mina</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/miyama_test.jpg" alt="">
          <p class="other_member_name">Miyama<br />Tomohiro</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div> -->




        <div class="Member_Member_wrap">
          <div class="Member_Member_item Member_Member_img_Animation1" data-cursor-hover><router-link to="MemberInterview1">
            <img src="../../assets/member/icon_422A8495_2048px.jpg">
            <p class="Member_Member_item_role en_font">senior engineer</p>
            <p class="Member_Member_item_text en_font">Takahiro.O</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

          <div class="Member_Member_item Member_Member_img_Animation1" data-cursor-hover><router-link to="MemberInterview2">
            <img v-lazy="require('@/assets/member/icon_422A8652_2048px.jpg')">
            <p class="Member_Member_item_role en_font">leader engineer</p>
            <p class="Member_Member_item_text en_font">Yuta.T</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

          <div class="Member_Member_item Member_Member_img_Animation2" data-cursor-hover><router-link to="MemberInterview3">
            <img v-lazy="require('@/assets/member/icon_422A8581_2048px.jpg')">
            <p class="Member_Member_item_role en_font">general affairs</p>
            <p class="Member_Member_item_text en_font">Chiaki.O</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

          <!-- <div class="Member_Member_item Member_Member_img_Animation3" data-cursor-hover><router-link to="MemberInterview4">
            <img v-lazy="require('@/assets/member/icon_422A8539_2048px.jpg')">
            <p class="Member_Member_item_role en_font">engineer</p>
            <p class="Member_Member_item_text en_font">Mina.Y</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div> -->

          <div class="Member_Member_item Member_Member_img_Animation4" data-cursor-hover><router-link to="MemberInterview5">
            <img v-lazy="require('@/assets/member/icon_422A8423_2048px.jpg')">
            <p class="Member_Member_item_role en_font">engineer</p>
            <p class="Member_Member_item_text en_font">Tomohiro.M</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

        </div>
        <div class="cb" />


      </div>

    </div>
  
  
  </div>
</body>
</template>


<style>
@import "../../css/Portal_base.css";
@import "../../css/Portal_base_memberinterview.css";

</style>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)

export default {
  data () {
    return {

    }
  },
  methods: {
    startMaintitle() {
      gsap.fromTo('.Member_Member_img_Animation1', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation2', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.3,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation3', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.6,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation4', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.9,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation5', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 2.1,
          opacity: 1,
        }
      )
    }
  },
  mounted() {
    this.startMaintitle()
  }
}

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

</script>
